import GridFrameworkComponents from 'components/Grid/GridFrameworkComponents';

// The cell and header renderers a DataTable can draw, by the name a column
// definition gives them (`cellRenderer: 'currencyCell'`). For now they're
// AG Grid's renderers, fed AG-shaped params by agParamsShim, so DataTable
// views take them from here instead of from components/Grid. Phase 6 (native
// columns) replaces the entries one at a time.
const DataTableRenderers: { [name: string]: React.ComponentType<any> } =
  GridFrameworkComponents;

export default DataTableRenderers;
